<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <sidebar-fixed-toggle-button />
    <side-bar
        :background-color="sidebarBackground"
        :short-title="$t('sidebar.shortTitle')"
        :title="$t('sidebar.title')"
    >
      <template slot="links">
        <sidebar-item
            v-for="(item) in evaluationList"
            :link="{
            name: item.auswertung,
            path: `/evaluation/${item.auswid}`
          }"
        >
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>
      <router-view name="header"></router-view>
      <div
          :class="{ content: !$route.meta.hideContent }"
          @click="toggleSidebar"
      >
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { ZoomCenterTransition } from 'vue2-transitions';
import { useEvaluationListStore } from '@/store';
import { useEvaluationAgeStore } from '@/store';
import { useEvaluationMapStore } from '@/store';
import { useEvaluationYearStore } from '@/store';
import { useEvaluationKvStore } from '@/store';
import { mapState, mapActions } from 'pinia';

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    SidebarFixedToggleButton,
    ZoomCenterTransition,
  },
  computed: {
    ...mapState(useEvaluationListStore, ['evaluationList']),
    ...mapState(useEvaluationAgeStore, ['evaluationAgeList']),
    ...mapState(useEvaluationMapStore, ['evaluationKvList']),
    ...mapState(useEvaluationYearStore, ['evaluationYearList']),
    ...mapState(useEvaluationKvStore, ['evaluationKvChartList']),
  },
  mounted () {
    this.initScrollbar();
    this.loadEvaluations();

    //const auswid = 1000;
    const auswid = this.$route?.params?.id;
    const yearAuspridRoh = 11;
    const kvAuspridRoh = 11;

    this.loadAgeChartData(auswid);
    this.loadYearChartData(auswid, yearAuspridRoh);

    this.loadMapChartData(auswid);
    this.loadKvChartData(auswid, kvAuspridRoh);
  },
  data() {
    return {
      sidebarBackground: 'blue' ,//vue|blue|orange|green|red|primary
    };
  },
  methods: {
    ...mapActions(useEvaluationListStore, ['loadEvaluations']),
    ...mapActions(useEvaluationAgeStore, ['loadAgeChartData']),
    ...mapActions(useEvaluationMapStore, ['loadMapChartData']),
    ...mapActions(useEvaluationYearStore, ['loadYearChartData']),
    ...mapActions(useEvaluationKvStore, ['loadKvChartData']),
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
    initScrollbar() {
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('main-panel');
        initScrollbar('sidebar-wrapper');

        docClasses.add('perfect-scrollbar-on');
      } else {
        docClasses.add('perfect-scrollbar-off');
      }
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
